import { Component, computed, inject, input } from '@angular/core';
import type { TextField } from '@core/jss-proxy';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { JssPlatformService } from '@core/jss-platform';
import { DEFAULT_TEXT_FIELD } from '@core/jss-utils';
import { CrntIcon } from '@essent/current-web-angular';

const THREE_USPS = 3;
const FOUR_USPS = 4;

@Component({
  selector: 'wl-simple-usp',
  standalone: true,
  templateUrl: './simple-usp.component.html',
  styleUrls: [
    './simple-usp.component.ed.scss',
    './simple-usp.component.essent.scss',
  ],
  imports: [CoreJssProxyModule, CrntIcon],
})
export class SimpleUspComponent {
  readonly #jssPlatformService = inject(JssPlatformService);

  readonly usp1 = input<TextField>(DEFAULT_TEXT_FIELD);
  readonly usp2 = input<TextField>(DEFAULT_TEXT_FIELD);
  readonly usp3 = input<TextField>(DEFAULT_TEXT_FIELD);
  readonly usp4 = input<TextField>();

  readonly isContentEditorActive = this.#jssPlatformService.isEditorActive();

  readonly showUsp4 = computed(
    () => this.isContentEditorActive || Boolean(this.usp4()?.value)
  );

  protected readonly FOUR_USPS = FOUR_USPS;
  protected readonly THREE_USPS = THREE_USPS;
}
